import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Encoding Settings',
  attributeName: 'encodingSetting',
  fields: [
    {
      attributeName: 'isEncrypt',
      type: FormInputTypes.TEXT,
      label: 'Encrypted',
      helpText: 'Checked if you want to encrypt the video output.',
    },
    {
      attributeName: 'drm_provider',
      type: FormInputTypes.TEXT,
      label: 'DRM Provider',
      helpText: 'Checked the DRM provider.',
    },
    {
      attributeName: 'videoCodec',
      type: FormInputTypes.TEXT,
      label: 'Video Codec',
      helpText: 'Video codec to use for processing.',
    },
    {
      attributeName: 'segmentLength',
      type: FormInputTypes.TEXT,
      label: 'Segment Length (ms)',
      helpText: 'Segment length in the output, it is in milliseconds format.',
    },
    {
      attributeName: 'isDiffStereo',
      type: FormInputTypes.TEXT,
      label: 'Differential stereo',
      helpText: 'Differential stereo is to apply YBVR differential stereo encoding feature.',
    },
    {
      attributeName: 'audioCodec',
      type: FormInputTypes.TEXT,
      label: 'Audio Codec',
      helpText: 'The audio codec to apply in all the job.',
    },
    {
      attributeName: 'quality_level',
      type: FormInputTypes.TEXT,
      label: 'Quality Levels',
      helpText: 'The quality level to apply in all the job.',
    },
    {
      attributeName: 'audioBitrate',
      type: FormInputTypes.TEXT,
      placeholder: 'Audio bitrate...',
      label: 'Audio bitrate (kbps)',
      helpText: 'The audio bitrate to apply in kbps.',
    },
    {
      attributeName: 'audio_variants',
      type: FormInputTypes.JSON_COMPONENT,
      canCreate: false,
      canEdit:false,
      canRemove: false,
      placeholder: 'Audio variants...',
      label: 'Audio variants',
      helpText: 'The audio variants available.',
      itemLabel: 'Audio variant',
      popupFormGroups: [{
        fields: [
          {
            attributeName: 'audioLanguage',
            type: FormInputTypes.TEXT,
            label: 'Language',
          },
          {
            attributeName: 'audioVariant',
            type: FormInputTypes.TEXT,
            label: 'audioVariant',
          },
          {
            attributeName: 'audioChannel',
            type: FormInputTypes.TEXT,
            label: 'audioChannel',
          },
        ],
      },],
    },
    {
      attributeName: 'subtitle_variants',
      type: FormInputTypes.JSON_COMPONENT,
      placeholder: 'Subtitle variants...',
      label: 'Subtitle variants',
      helpText: 'The subtitle variants available.',
      canCreate: false,
      canEdit:false,
      canRemove: false,
      itemLabel: 'Subtitle variant',
      popupFormGroups: [{
        fields: [
          {
            attributeName: 'captions',
            type: FormInputTypes.CHECKBOX,
            label: 'Captions',
          },
          {
            attributeName: 'subtitleVariant',
            type: FormInputTypes.TEXT,
            label: 'Subtitle',
            hidden: (item) => !item?.subtitleLanguage 
          },
          {
            attributeName: 'subtitleLanguage',
            type: FormInputTypes.TEXT,
            label: 'Language',
          }
        ],
      },],
    },
  ],
};
